import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import CandidateDetailSkeleton from "./CandidateDetailSkeleton";
import { updateActiveDetailListing } from "../../../../../../reducers/clientcandidatedetail";
import { getComplianceClass } from "../../../../../../utilities/utils";
import ReadMoreWrapper from "../../../../ReadMoreWrapper";
import { Miles } from "../../../candidates/Listing/common/Miles";
import BlurredText from "../../../managedService/BlurredText";

const CandidateRightProfile = () => {
  const { candidateDetails, showProfile, candidateDetLoading } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  const { user } = useSelector((state) => state.clientProfile);

  const {
    address = "-",
    candidate_postcode = "-",
    profile_percent,
    shift_completed,
    miles,
    mobile_phone_number,
    candidate_email,
    work_email,
    is_past_booking,
  } = candidateDetails;
  const dispatch = useDispatch();
  let newAddress = address?.includes(candidate_postcode)
    ? address
    : address + ", " + candidate_postcode;

  return (
    <div className="CandidateRightProfile_wrapper grid gap-[24px] px-4">
      <div className={`rounded-lg border border-txtGreyDark bg-grey p-4`}>
        <div className="flex flex-wrap justify-between gap-x-5 gap-y-5">
          {candidateDetLoading ? (
            Array.from({ length: 4 }).map((_, index) => (
              <Fragment key={index}>
                <CandidateDetailSkeleton.CandidateRightProfile />
              </Fragment>
            ))
          ) : (
            <>
              <div className="grid items-start gap-[6px]">
                <div className="grid gap-[6px]">
                  <span className="text-sm font-semibold leading-[normal] text-txtColor">
                    Registration Number
                  </span>
                  <span className="text-base font-semibold leading-[normal] text-black">
                    {candidateDetails?.license_number || "-"}
                  </span>
                  {/* <Miles miles={miles || "-"} /> */}
                </div>
              </div>
              <div className="grid items-start gap-[6px]">
                <div className="grid gap-[6px]">
                  <span className="text-sm font-semibold leading-[normal] text-txtColor">
                    Smartcard Number
                  </span>
                  <span className="text-base font-semibold leading-[normal] text-black">
                    {candidateDetails?.smart_card_number || "-"}
                  </span>
                  {/* <Miles miles={miles || "-"} /> */}
                </div>
              </div>
              <div className="grid items-start gap-[6px]">
                <div className="grid gap-[6px]">
                  <span className="text-sm font-semibold leading-[normal] text-txtColor">
                    Shifts Completed
                  </span>
                  <div
                    className="w-fit cursor-pointer text-base font-semibold leading-[normal] text-black"
                    onClick={() => {
                      dispatch(updateActiveDetailListing("workHistory"));
                    }}
                  >
                    {candidateDetails?.shift_completed || "-"}
                  </div>
                  {/* <Miles miles={miles || "-"} /> */}
                </div>
              </div>
              <div className="grid items-start gap-[6px]">
                <div className="grid gap-[6px]">
                  <span className="text-sm font-semibold leading-[normal] text-txtColor">
                    Candidate compliance
                  </span>
                  <div
                    className={`text-base ${getComplianceClass(
                      profile_percent,
                    )} flex h-[25px] w-[65px] items-center justify-center rounded-[4px] text-center`}
                    role="button"
                    onClick={() => {
                      dispatch(updateActiveDetailListing("compliance"));
                    }}
                  >
                    {candidateDetails?.profile_percent || "0"}%
                  </div>
                  {/* <Miles miles={miles || "-"} /> */}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {candidateDetLoading ? (
          Array.from({ length: 5 }).map((_, index) => (
            <Fragment key={index}>
              <CandidateDetailSkeleton.CandidateRightProfile />
            </Fragment>
          ))
        ) : (
          <>
            <div className="grid items-start gap-[6px]">
              <div className="grid gap-[6px]">
                <span className="text-sm font-semibold leading-[normal] text-txtColor">
                  Personal Address
                </span>
                <div className="flex flex-col">
                  <BlurredText type="address">
                    <ReadMoreWrapper
                      cls="text-txtDark pr-2 font-medium"
                      text={newAddress}
                      readMoreText={
                        <>
                          <span className="text-primary"> Read More</span>
                        </>
                      }
                      readLessText={
                        <>
                          <span className="text-primary"> Read Less</span>
                        </>
                      }
                      max={70}
                    />
                  </BlurredText>
                </div>
                {/* <Miles miles={miles || "-"} /> */}
              </div>
            </div>
            <div className="grid items-start gap-[6px]">
              <div className="grid gap-[6px]">
                <span className="text-sm font-semibold leading-[normal] text-txtColor">
                  Distance to practice
                </span>
                <Miles miles={miles || "-"} />
                {/* <Miles miles={miles || "-"} /> */}
              </div>
            </div>
            <div className="grid items-start gap-[6px]">
              <div className="grid gap-[6px]">
                <span className="text-sm font-semibold leading-[normal] text-txtColor">
                  Contact Number
                </span>
                <BlurredText type="phone">
                  <span className="text-md break-all font-medium leading-[normal] text-txtDark">
                    {mobile_phone_number || "-"}
                  </span>
                </BlurredText>
              </div>
            </div>

            <div className="grid items-start gap-[6px]">
              <div className="grid gap-[6px]">
                <span className="text-sm font-semibold leading-[normal] text-txtColor">
                  Email Address
                </span>
                <div className="flex flex-col">
                  <BlurredText type="email">
                    <span className="text-md inline-block break-all font-medium leading-[normal] text-txtDark">
                      {candidate_email || "-"}
                    </span>
                  </BlurredText>
                </div>
              </div>
            </div>
            <div className="grid items-start gap-[6px]">
              <div className="grid gap-[6px]">
                <span className="text-sm font-semibold leading-[normal] text-txtColor">
                  Work email address
                </span>
                <div className="flex flex-col">
                  <span className="text-md inline-block break-all font-medium leading-[normal] text-txtDark">
                    {work_email || "-"}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {/* <hr className="my-4 border-t-lightblue" /> */}
    </div>
  );
};

export default CandidateRightProfile;
